<li class="nav-item dropdown" dropdown #dropdown="bs-dropdown" (mouseleave)="dropdown.hide()">
  <a href="#" dropdownToggle class="nav-link dropdown-toggle" (mouseenter)="dropdown.show()" routerLink="/about">About</a>
  <ul *dropdownMenu class="dropdown-menu" role="menu">
    <li role="menuitem"><a class="dropdown-item" href="#" routerLink="faq">FAQ</a></li>
    <li class="divider dropdown-divider"></li>
    <li role="menuitem"><a class="dropdown-item" href="#" routerLink="contact">Contact Us</a></li>
    <li role="menuitem"><a class="dropdown-item" href="#" routerLink="about">About Us</a></li>
  </ul>
</li>
